export default __webpack_public_path__ + "static/media/right-foot-not-selected.7d77f361.svg";